<template>
  <div class="custom-section-box">
    <table class="info-table" v-if="editData">
      <tr>
        <td>
          <span class="label">Title:</span>
          <span class="value">{{ editData.titleObj ? editData.titleObj.enName : null }}</span>
        </td>
        <td colspan="2">
          <span class="label">Name:</span>
          <span class="value">{{ editData.fullName ? editData.fullName.replace(/,/g, ', ') : '' }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">Gender:</span>
          <span class="value">{{ editData.gender == 'M' ? 'Male' : 'Female' }}</span>
        </td>
        <td>
          <span class="label">Birthdate:</span>
          <span class="value">{{ dateFormatB(editData.birthday) }}</span>
        </td>
        <td>
          <span class="label">Primary language:</span>
          <span class="value">{{ editData.languageObj ? editData.languageObj.enName : null }}</span>
        </td>
        <td>
          <span class="label">Other languages:</span>
          <span class="value">{{ editData.otherLanguageNames }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">Origin:</span>
          <span class="value">{{ editData.nationalBackgroundObj ? editData.nationalBackgroundObj.enName : null }}</span>
        </td>
        <td colspan="3">
          <span class="label">Ethnicities:</span>
          <span class="value">{{ editData.ethnicitiesObj ? editData.ethnicitiesObj.enName : null }}</span>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <span class="label">Email:</span>
          <span class="value email-list" v-if="editData.contactList && editData.contactList.length > 0">
            <span v-for="(item, index) in editData.contactList.filter(e => e.contactType == '1')" :key="item.id + '-' + index" class="email-item">{{ item.email }}</span>
          </span>
        </td>
        <td colspan="2">
          <span class="label">Phone:</span>
          <span class="value email-list" v-if="editData.contactList && editData.contactList.length > 0">
            <span v-for="(item, index) in editData.contactList.filter(e => e.contactType == '2')" :key="item.id + '-' + index" class="email-item">
              <template v-if="item.phoneCountryCallingCode && item.phoneNumber">+{{ item.phoneCountryCallingCode }} {{ item.phoneNumber }}</template> <template v-if="item.phoneExt">Ext.{{ item.phoneExt }}</template>
            </span>
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <span class="label">Mailing Info:</span>
          <span class="value" v-if="hasValidAddress(editData.addressList)">
            <div v-for="(item, index) in editData.addressList" :key="item.id + '-' + index">{{ formatAddress(item) }}</div>
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <span class="label">Emergency Contact:</span>
          <span class="value" v-if="emergencyContact && (emergencyContact.realationShipName || emergencyContact.lastName || emergencyContact.firstName || emergencyContact.phoneNumber || emergencyContact.phoneExt || emergencyContact.email)">
            <div class="contact-info">
              <span v-if="emergencyContact.realationShipName">{{ emergencyContact.realationShipName }}</span>
              <span v-if="emergencyContact.lastName || emergencyContact.firstName">{{ emergencyContact.lastName }} {{ emergencyContact.firstName }}</span>
              <span v-if="emergencyContact.phoneNumber || emergencyContact.phoneExt">+{{ emergencyContact.phoneCountryCallingCode }} {{ emergencyContact.phoneNumber }} <template v-if="emergencyContact.phoneExt">Ext.{{ emergencyContact.phoneExt }}</template></span>
              <span v-if="emergencyContact.email">{{ emergencyContact.email }}</span>
            </div>
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <span class="label">Relationship:</span>
          <span class="value" v-if="editData.rsList && editData.rsList.length > 0">
            <div class="relationship-info">
              <span v-for="(item, index) in editData.rsList" :key="item.id + '-' + index">
                {{ item.relationshipId ? (realationShipList.find(e => e.id == item.relationshipId).rsName) : '' }} {{ item.globalCode }}
              </span>
            </div>
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>

export default {
  name: 'CdbCustomerBasic',
  components: {
  },
  props: {
    initData: {
      type: [Object],
      default: null
    },
    titleList: {
      type: [Array],
      default: null
    },
    backgroundList: {
      type: [Array],
      default: null
    },
    ethnicitiesList: {
      type: [Array],
      default: null
    },
    languageList: {
      type: [Array],
      default: null
    },
    initEmergencyContact: {
      type: [Object],
      required: true
    },
    realationShipList: {
      type: [Array],
      default: null
    }
  },
  data () {
    return {
      editData: null,
      emergencyContact: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 初始化数据
    async loadData() {
      this.editData = this.initData
      this.emergencyContact = this.initEmergencyContact
      const titleObj = this.titleList.find(e => e.code == this.editData.title)
      const languageObj = this.languageList.find(e => e.code == this.editData.languages)
      const nationalBackgroundObj = this.backgroundList.find(e => e.code == this.editData.nationalBackground)
      const ethnicitiesObj = this.ethnicitiesList.find(e => e.code == this.editData.ethnicitiesId)
      if (titleObj) {
        this.editData.titleObj = titleObj
      }
      if (languageObj) {
        this.editData.languageObj = languageObj
      }
      if (nationalBackgroundObj) {
        this.editData.nationalBackgroundObj = nationalBackgroundObj
      }
      if (ethnicitiesObj) {
        this.editData.ethnicitiesObj = ethnicitiesObj
      }
      if (this.emergencyContact && this.realationShipList && this.realationShipList.length > 0) {
        const relation = this.realationShipList.find(e => e.id == this.emergencyContact.realationShip)
        if (relation) {
          this.emergencyContact.realationShipName = relation.rsName
        }
      }
      if (this.editData.otherLanguages && this.languageList) {
        this.editData.otherLanguageNames = this.getOtherLanguageNames()
      }
		},
    getOtherLanguageNames() {
      if (!this.editData.otherLanguages || !this.languageList) return ''
      const languageCodes = this.editData.otherLanguages
        .split(',')
        .map(code => code.trim())
        .filter(code => code)

      const languageNames = languageCodes.map(code => {
        const lang = this.languageList.find(item => item.code === code)
        return lang ? lang.enName : null
      }).filter(name => name)

      return languageNames.join(', ')
    },
    handleEdit () {
      this.$emit('onEdit')
    },
    formatAddress (item) {
      if (!item) return ''
      const parts = [
        item.detail,
        item.cityInput,
        item.state?.nameEnUs,
        item.zipcode
      ].filter(Boolean)
      
      return [
        parts.join(', '),
        item.country?.code
      ].filter(Boolean).join(', ')
    },
    hasValidAddress (addressList) {
      if (!addressList?.length) return false
      return addressList.some(item => {
        return (item.detail && item.detail.trim()) || 
              (item.cityInput && item.cityInput.trim()) || 
              (item.state && item.state.nameEnUs && item.state.nameEnUs.trim()) || 
              (item.zipcode && item.zipcode.trim()) || 
              (item.country && item.country.code)
      })
    }
	},
  watch: {
  }
}
</script>
<style lang="less" scoped>
.custom-section-box {
  color: #333;
  font-size: 16px;

  .info-table {
    td {
      padding: 4px;
      vertical-align: top;

      .label {
        font-weight: bold;
        margin-right: 6px;
      }
      .value {
        word-break: break-all;
        display: inline-block;
        .email-item:not(:last-child):after {
          content: "; ";
        }
        .contact-info {
          span:not(:last-child) {
            margin-right: 10px;
            &:not(:first-child):after {
              content: "|";
              margin-left: 10px;
              color: #333;
              font-weight: 600;
            }
          }
        }
        .relationship-info {
          span:not(:last-child) {
            margin-right: 10px;
            &:not(:last-child):after {
              content: "|";
              margin-left: 10px;
              color: #333;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}
</style>
